"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterButton = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Badge_1 = __importDefault(require("@material-ui/core/Badge"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
const field_filter_hook_1 = require("../../field-filter/field-filter-hook");
const table_field_toolbar_button_1 = require("../table-field-toolbar-button");
const filter_dialog_1 = require("./filter-dialog");
function FilterButton({ preFilters = [], filtersFields, source, color, variant, }) {
    const dialogRef = (0, react_1.useRef)(null);
    const { filters, reset, handleFilterValueChange, handleFilterStateChange, search, } = (0, field_filter_hook_1.useFilters)({
        source,
        filtersFields,
        preFilters,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_field_toolbar_button_1.TableFieldToolbarButton, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_FILTER_DIALOG_OPEN", defaultMessage: "Nastaven\u00ED filtr\u016F" }), onClick: () => { var _a; return (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open(); }, IconComponent: FilterList_1.default, disabled: !(filtersFields !== null && filtersFields !== void 0 ? filtersFields : []).length, show: true, color: color, variant: variant },
            react_1.default.createElement(Badge_1.default, { badgeContent: filters.filter((f) => !!f.value).length, color: "error" },
                react_1.default.createElement(Typography_1.default, { variant: "body2" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_FIELD_TOOLBAR_BTN_FILTER", defaultMessage: "filtry" })))),
        react_1.default.createElement(filter_dialog_1.TableFieldFilterDialog, { ref: dialogRef, filtersFields: filtersFields, filters: filters, reset: reset, handleFilterValueChange: handleFilterValueChange, handleFilterStateChange: handleFilterStateChange, search: search })));
}
exports.FilterButton = FilterButton;
//# sourceMappingURL=filter-button.js.map